import { REQUEST_MENTION_SUCCESS, REQUEST_MENTION_FAILURE, REQUEST_UNREAD_MENTION_SUCCESS,REQUEST_UNREAD_MENTION_FAILURE, REQUEST_MENTION_START, REQUEST_UNREAD_MENTION_START, REQUEST_MENTIONS_START, REQUEST_POST_TEXT_MESSAGE,REQUEST_POST_MESSAGES_EMPTY } from '../constants/actionTypes';

const INITIAL_STATE = { list: [], isLoading: true, messages: [], errors: null, isLoadingMention: false };

export default function mentionList(state = INITIAL_STATE, action) {

  switch (action.type) {
    case REQUEST_MENTION_START:
      return { ...state, isLoadingMention: true }
    case REQUEST_MENTIONS_START:
      return { ...state, isLoading: true }
    case REQUEST_UNREAD_MENTION_SUCCESS:
      return { ...state, list: action.payload, errors: null, isLoading: false }
    case REQUEST_MENTION_SUCCESS:
      return { ...state, messages: action.payload, errors: null, isLoadingMention: false }
    case REQUEST_MENTION_FAILURE:
      return { ...state, messages: [], errors: "list not returned", isLoadingMention: false, isLoading: false }
    // case REQUEST_POST_TEXT_MESSAGE: {
    //   return { ...state, messages: [...state.messages, { ...action.payload }] }
    // }
    case REQUEST_POST_MESSAGES_EMPTY: 
      return { ...state, messages: [] }
    case REQUEST_UNREAD_MENTION_FAILURE:
      return { ...state, data: {}, errors: "list not returned" ,isLoadingMention: false , isLoading: false }
    default:
      return state;
  }
}
